import datapoints from '../datapoints';
import removeInboxRuleService from '../services/removeInboxRuleService';
import { InboxRulesListOptionState } from '../store/schema/InboxRulesListOptionState';
import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
import InboxRuleRetryDialog from '../components/InboxRuleRetryDialog';
import { logUsage } from 'owa-analytics/lib/api';
import InboxRuleRowType from '../store/schema/InboxRuleRowType';

export interface RemoveInboxRuleOptionState {
    optionState: InboxRulesListOptionState;
}
/**
 * Removes the given rule
 * @param inboxRuleId the inbox rule id
 */
export default select<RemoveInboxRuleOptionState>({
    optionState: () => store.inboxRulesListState,
})(
    action('removeInboxRule', datapoints.removeInboxRuleDatapoint)(function removeInboxRule(
        inboxRule: InboxRuleRowType,
        force?: boolean,
        alwaysDeleteOutlookRulesBlob?: boolean,
        state?: RemoveInboxRuleOptionState
    ) {
        let { optionState } = state;
        let inboxRuleId = inboxRule.Identity.RawIdentity;
        let ruleIdIndex = optionState.inboxRuleIds.indexOf(inboxRuleId);
        if (ruleIdIndex > -1) {
            optionState.inboxRules.delete(inboxRuleId);
            optionState.inboxRuleIds.splice(ruleIdIndex, 1);
        }

        // TODO: Task 20143: Full error handling / success notification support
        return removeInboxRuleService(inboxRule, force, alwaysDeleteOutlookRulesBlob)
            .then(response => {
                if (!response.WasSuccessful) {
                    // add the rule back to the list on failure
                    optionState.inboxRules.set(inboxRuleId, inboxRule);
                    optionState.inboxRuleIds.splice(ruleIdIndex, 0, inboxRuleId);

                    if (response.UserPrompt) {
                        let dialog = new InboxRuleRetryDialog(
                            response.UserPrompt,
                            isChecked =>
                                removeInboxRule(
                                    inboxRule,
                                    true /*force*/,
                                    isChecked /*alwaysDeleteOutlookRulesBlob*/,
                                    { optionState: store.inboxRulesListState }
                                ),
                            () => {}
                        );
                        dialog.show();
                    }
                    logUsage(datapoints.inboxRuleActionFailDatapoint.datapoint.name, [
                        'RemoveInboxRule',
                    ]);
                }
                return Promise.resolve();
            })
            .catch(error => {
                logUsage(datapoints.inboxRuleActionFailDatapoint.datapoint.name, [
                    'RemoveInboxRule',
                ]);
                return Promise.resolve();
            });
    })
);
